import { combineReducers } from "redux";
import { reportsReducer } from "./Reports/__redux/reducers";

export const accountingReducer = combineReducers({
	reports: reportsReducer,
});
